import { Navigate } from "react-router-dom";
import { useIsAuthenticated, useAuth } from "../hooks/useAuth";
import { SignupForm } from "../components/auth/SignupForm";

export function Signup() {
  const isAuthenticated = useIsAuthenticated();
  const { loading } = useAuth();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[radial-gradient(circle_at_top,_rgba(37,99,235,0.10),_transparent_45%),linear-gradient(180deg,_#f8fafc,_#eef2ff)]">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-brand-600 border-t-transparent" />
      </div>
    );
  }
  if (isAuthenticated) return <Navigate to="/onboarding" replace />;

  return (
    <div className="flex min-h-screen items-center justify-center bg-[radial-gradient(circle_at_top,_rgba(37,99,235,0.10),_transparent_45%),linear-gradient(180deg,_#f8fafc,_#eef2ff)] px-4 py-10">
      <div className="w-full max-w-md rounded-[28px] border border-slate-200 bg-white/95 p-3 shadow-[0_20px_60px_-24px_rgba(15,23,42,0.25)] backdrop-blur">
        <SignupForm />
      </div>
    </div>
  );
}
